<template>
  <appointments-search-results></appointments-search-results>
</template>

<script>
export default {};
</script>
